"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceCalculationsView = void 0;
const job_1 = require("./job");
const typeorm_1 = require("typeorm/browser");
const invoicing_target_1 = require("./invoicing-target");
const supplier_types_enum_1 = require("./supplier-types-enum");
const service_view_1 = require("./service-view");
let PriceCalculationsView = class PriceCalculationsView {
};
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "revenue", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "costs", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "priceListingSum", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "priceSellingSum", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "pricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "serviceTotalMinutes", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "servicePricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], PriceCalculationsView.prototype, "productsPricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], PriceCalculationsView.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => job_1.Job, (job) => job.priceCalculationsView),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id' }),
    __metadata("design:type", job_1.Job)
], PriceCalculationsView.prototype, "job", void 0);
PriceCalculationsView = __decorate([
    (0, typeorm_1.ViewEntity)({
        dependsOn: [service_view_1.ServiceView],
        expression: `
    SELECT
      prices.price_listing_sum + prices.price_selling_sum AS revenue,
      prices.price_purchasing_sum AS costs,
      prices.*
    FROM (
      SELECT
        (
          COALESCE((
            SELECT
              SUM(price_lists_sum__c)
            FROM public.job_service__c
            WHERE job_id = job.api_id__c
              AND is_active__c = True
              AND invoicing_target__c IN (
                '${invoicing_target_1.InvoicingTargetEnum.CUSTOMER}',
                '${invoicing_target_1.InvoicingTargetEnum.CUSTOMER_2}'
              )
          ),0) +
          COALESCE((
            SELECT
              SUM(price_lists_sum)
            FROM public.job_additional_items
            WHERE job_api_id = job.api_id__c
              AND invoicing_target IN (
                '${invoicing_target_1.GeneralInvoicingTargetEnum.CUSTOMER}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.CUSTOMER_SECOND}'
              )
          ),0) +
          COALESCE((
            SELECT
              SUM(price_listing * quantity)
            FROM public.job_product
            WHERE job_api_id = job.api_id__c
              AND invoicing_target IN (
                '${invoicing_target_1.GeneralInvoicingTargetEnum.CUSTOMER}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.CUSTOMER_SECOND}'
              )
          ),0) +
          COALESCE((
            SELECT SUM(price_lists_sum)
            FROM public.custom_service
            WHERE job_api_id = job.api_id__c
              AND invoicing_target IN (
                '${invoicing_target_1.GeneralInvoicingTargetEnum.CUSTOMER}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.CUSTOMER_SECOND}'
              )
          ), 0)
        ) price_listing_sum,
        (
          COALESCE((
            SELECT SUM(price_selling_sum__c)
            FROM public.job_service__c
            WHERE job_id = job.api_id__c
              AND is_active__c = True
              AND invoicing_target__c IN (
                '${invoicing_target_1.InvoicingTargetEnum.BRAND}',
                '${invoicing_target_1.InvoicingTargetEnum.BRAND_1}',
                '${invoicing_target_1.InvoicingTargetEnum.BRAND_2}',
                '${invoicing_target_1.InvoicingTargetEnum.AFFILIATE}'
          )
          ),0) +
          COALESCE((
            SELECT SUM(price_selling_sum)
            FROM public.job_additional_items
            WHERE job_api_id = job.api_id__c
              AND invoicing_target IN (
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND_1}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND_2}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.AFFILIATE}'
              )
          ),0) +
          COALESCE((
            SELECT
              SUM(price_selling * quantity)
            FROM public.job_product
            WHERE job_api_id = job.api_id__c
              AND invoicing_target IN (
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND_1}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND_2}'
              )
              AND supplier = '${supplier_types_enum_1.SupplierTypesEnum.GID}'
          ),0)+
          COALESCE((
            SELECT SUM(price_selling_sum)
            FROM public.custom_service
            WHERE job_api_id = job.api_id__c
              AND invoicing_target IN (
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND_1}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.BRAND_2}',
                '${invoicing_target_1.GeneralInvoicingTargetEnum.AFFILIATE}'
              )
          ), 0)
        ) price_selling_sum,
        (
          COALESCE((
            SELECT SUM(price_purchasing_sum__c)
            FROM public.job_service__c
            WHERE job_id = job.api_id__c
              AND is_active__c = True
          ),0) +
          COALESCE((
            SELECT SUM(price_purchasing_sum)
            FROM public.job_additional_items
            WHERE job_api_id = job.api_id__c
          ),0) +
          COALESCE((
            SELECT
              SUM(price_purchasing * quantity)
            FROM public.job_product
            WHERE job_api_id = job.api_id__c
              AND supplier = '${supplier_types_enum_1.SupplierTypesEnum.GID}'
          ),0)+
          COALESCE((
            SELECT SUM(price_purchasing_sum)
            FROM public.custom_service
            WHERE job_api_id = job.api_id__c
          ), 0)
        ) price_purchasing_sum,
        COALESCE((
          SELECT SUM(service.vor__c)
          FROM public.job_service__c job_service
          JOIN public.service service ON (
            job_service.Service__c = service.sfid
            AND service.opportunity__c = job.opportunity__c
          )
          WHERE job_service.job_id = job.api_id__c
            AND job_service.is_active__c = TRUE
        ),0) service_total_minutes,
        COALESCE((
          SELECT SUM(price_purchasing_sum__c)
          FROM public.job_service__c
          WHERE job_id = job.api_id__c
            AND is_active__c = True
        ),0) +
        COALESCE((
          SELECT SUM(price_purchasing_sum)
          FROM public.job_additional_items
          WHERE job_api_id = job.api_id__c
        ),0) +
        COALESCE((
          SELECT SUM(price_purchasing_sum)
          FROM public.custom_service
          WHERE job_api_id = job.api_id__c
        ), 0) service_price_purchasing_sum,
        COALESCE((
          SELECT
            SUM(price_purchasing * quantity)
          FROM public.job_product
          WHERE job_api_id = job.api_id__c
            AND supplier = '${supplier_types_enum_1.SupplierTypesEnum.GID}'
        ),0) products_price_purchasing_sum,
        job.api_id__c job_api_id
      FROM
        public.job__c job
    ) prices
  `,
    })
], PriceCalculationsView);
exports.PriceCalculationsView = PriceCalculationsView;
//# sourceMappingURL=price-calculations-view.js.map